import api from './api.js';

// ==================== CUSTOMER SUPPORT INBOX APIS (admin side) ====================

export const supportChatAPI = {
    // List all customer support conversations (inbox)
    getConversations: (params) => api.get('/api/support-chat/admin/conversations', { params }),

    // Message history for one conversation
    getMessages: (conversationId, params) =>
        api.get(`/api/support-chat/admin/conversations/${conversationId}/messages`, { params }),

    // Reply to a customer (optional file attachment)
    reply: (conversationId, text, file) => {
        const formData = new FormData();
        if (text) formData.append('text', text);
        if (file) formData.append('file', file);
        return api.post(`/api/support-chat/admin/conversations/${conversationId}/messages`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
    },

    // Close or reopen a conversation
    updateStatus: (conversationId, status) =>
        api.patch(`/api/support-chat/admin/conversations/${conversationId}/status`, { status }),

    // Mark a conversation as read
    markRead: (conversationId) =>
        api.post(`/api/support-chat/admin/conversations/${conversationId}/read`),

    // Support thread for an app user (profile page)
    getConversationByUser: (appUserId, params) =>
        api.get(`/api/support-chat/admin/users/${appUserId}/conversation`, { params }),
};

export default supportChatAPI;
